import { api } from "./api";
import { AxiosError, AxiosResponse } from 'axios';
import { AuthBodyType } from "./types";
import { ChamadoChecklist, chamadoConfigTypeSubitem } from "../components/Filling/Types";
import { ModeloQRCode } from "./QrCode";
import type { ChecklistType as RefactoredChecklistType } from "../types/checklist/types";

export type ticketConfigType = {
  serviceTypes: string[];
  limit: number;
  mandatory: string | boolean;
  blockDuplicates?: boolean;
};

export type linkType = {
  index: number;
  name: string;
  value: string;
  blocked?: boolean;
};

export type formToSend = {
  editavel?: {
    cancela?: boolean;
    clone?: boolean;
  };
  id: string;
  nome?: string;
  typeId?: string;
};

export type itemTypeToSend = {
  formId: string;
  itemIndex: number;
  item: {
    nome?: string;
    peso?: number;
  };
};

export type NewFormType = {
  nome: string;
  peso: number;
  subitens: [
    {
      id: number;
      nome: string;
      tipo: string;
      peso: number;
      threshold: number;
      avaliacao: {
        nome: string;
        valor: number;
      }[];
    },
  ];
};

export type conjuntoAssociadoTree = {
  checked: boolean;
  id: string;
  locaisList: {
    checked: boolean;
    id: string;
    conjuntosList: {
      checked: boolean;
      id: string;
    }[];
  }[];
};

export type notifiConfigType = {
  id: string;
  notifiEm: string;
};

export type ChecklistType = {
  fluxo?: string;
  aprovacaoConfig?: {
    numeroAprovadores: number;
    aprovacaoOrdenada: boolean;
  };
  valorMaxScoring?: number;
  ticketConfig?: ticketConfigType;
  dataAlteracao: number;
  dataCadastro: number;
  link: linkType[];
  editavel: {
    blockCancel?: boolean;
    blockClone?: boolean;
    cancela?: boolean;
    clone?: boolean;
    mandatory: boolean;
  };
  empresa: string;
  id: string;
  identificadorLista?: string;
  nome: string;
  status: boolean;
  userNome: string;
  versao: number;
  typeId: string;
  tipoServico?: string;
  nomeTipoServico?: string;
  itens: ItemChecklist[];
  equipesExcecao?: string[] | null;
  conjuntosAssociados?: string[];
  preenchimentoWeb?: boolean;
  preenchimentoDeslogado: boolean;
  abreChamado: {
    durante: boolean;
    apos: boolean;
  };
  range?: {
    [index: number]: string;
  };
  notifiConfig?: notifiConfigType[];
  modeloQrCode?: ModeloQRCode;
};

export type OptionsType = {
  chamadoObrigatorio: string;
  limiteChamado: number;
  nome: string;
  tipo: string;
  tipoChamado: number[];
};

export type ocorrenciaType = {
  id: number;
  itemId: string;
  nome: string;
  subitens: SubitemChecklist[];
};

export type ItemChecklist = {
  nomeOcorrencia?: string;
  ocorrenciaMultipla?: boolean;
  ocorrencias?: ocorrenciaType[];
  maxOcorrencias?: number | null;
  id: string;
  nome: string;
  peso?: number;
  subitens: ChecklistSubitem[];
  score?: number;
  scorePorcentagem?: string;
};

type NotificacaoModelo = {
  id: number | null;
  notificar: string | null;
};

export type ChecklistHelpType = {
  choose?: string;
  comentario?: string;
  video?: string;
  foto?: string;
  newPhoto?: boolean;
};

export type TipoSelecaoType = "user" | "local" | "cliente" | "conjunto" | "unidade" | "default";

export interface ChecklistSubitem {
  arquivos?: {
    nome: string;
    type: string;
    path: string;
  }[];
  permiteArquivo?: boolean;
  allowDecimal?: boolean;
  subtipo?: string | null;
  min?: number | null;
  max?: number | null;
  geraQrCode?: boolean;
  abrePlano?: boolean;
  score?: number;
  ticketConfig?: ticketConfigType;
  nota?: number;
  id: number;
  nome: string;
  itemid: string;
  itemid_old?: string | null;
  new_id?: string | null;
  avaliacao?: any[] | null;
  checked?: boolean | null;
  comentario?: boolean | null;
  foto?: boolean | null;
  galeriaFoto?: boolean | null;
  grupoNotificacao?: number | null;
  hideImg?: boolean | null;
  hideComent?: boolean | null;
  help?: ChecklistHelpType | null;
  minNumberVal?: number | null;
  maxNumberVal?: number | null;
  noDecimalNumber?: boolean | null;
  qtdeExataDecimalInput?: number | null;
  obrigatoriedade?: {
    img?: boolean | null;
    ocorrencia?: boolean | null;
    obrigaArquivo?: boolean;
    preenchimento?: boolean;
    conforme?: {
      img?: boolean;
      ocorrencia?: boolean;
      obrigaArquivo?: boolean;
    };
    naoConforme?: {
      img?: boolean;
      ocorrencia?: boolean;
      obrigaArquivo?: boolean;
    };
    NA?: {
      img?: boolean | null;
      ocorrencia?: boolean | null;
      obrigaArquivo?: boolean;
    } | null;
  } | null;
  padrao?: any | null;
  padraoMultiple?: any[] | null;
  padraoLista?: string[] | null;
  peso?: number | null;
  selecao?: any[] | null;
  selecionados?: any[] | null;
  threshold?: number;
  tipo: string;
  tipoChamado?: number | null;
  tipoNotificacao?: NotificacaoModelo | null;
  assinatura?: string;
  chamadosConfig?: chamadoConfigTypeSubitem;
  chamados?: ChamadoChecklist[];
  tipoSelecao?: TipoSelecaoType;
  ocorrencia?: string;
  img?: string[];
  scorePorcentagem?: string;
  obs?: string;
}

export type SubitemChecklist = {
  ticketConfig?: ticketConfigType;
  avaliacao?: {
    nome: string;
    valor: number;
  }[];
  selecionados?: boolean[];
  selecao?: string[];
  chamados?: ChamadoChecklist[];
  chamadosConfig?: chamadoConfigTypeSubitem;
  checked?: boolean;
  comentario: boolean;
  foto: boolean;
  galeriaFoto: boolean;
  id: number;
  itemid: string;
  maxNumberVal: number;
  minNumberVal: number;
  new_id: string;
  nome: string;
  img?: string[];
  arquivos?: {
    nome: string;
    type: string;
    path: string;
  }[];
  obrigatoriedade: {
    NA: {
      img: boolean;
      ocorrencia: boolean;
    };
    img: boolean;
    ocorrencia: boolean;
    preenchimento: boolean;
  };
  padrao: string;
  tipo: string;
};

export type simpleFormType = {
  id: string;
  nome: string;
  conjs: string[];
  equipes: string[];
};

class Checklists {


  changeFormStatus = async (body: AuthBodyType, formId: string, status: boolean) => {
    const data: AxiosResponse = await api.post("/checklists/changeFormStatus", {
      ...body,
      formId,
      status,
    });
    return data;
  };

  getFormById = async (body: AuthBodyType, formId: string) => {
    const data: AxiosResponse = await api.post("/checklists/getFormById", {
      ...body,
      formId,
    });
    return data;
  };

  getChecklistIndexes = async (body: AuthBodyType, itensPerPage: number) => {
    try {
      const data: AxiosResponse = await api.post("/checklists/getChecklistIndexes", {
        ...body,
        itensPerPage,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        return error.response?.status;
      }
    }
  };

  getListV2 = async (body: AuthBodyType & { empresa: string; itensPerPage: number; lastIndex: number | null; filter: string | null }) => {
    try {
      const data: AxiosResponse = await api.post("/checklists/getListV2", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  newForm = async (body: AuthBodyType, nome: string, itemData: NewFormType[], preenchimentoWeb: boolean, preenchimentoDeslogado: boolean) => {
    try {
      const data: AxiosResponse = await api.post("/checklists/newForm", {
        ...body,
        nome,
        itemData,
        preenchimentoWeb,
        preenchimentoDeslogado,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  deleteForm = async (body: AuthBodyType & { form: string }) => {
    try {
      const data: AxiosResponse = await api.post("/checklists/deleteForm", {
        ...body,
      });
      return data.data.forms;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  changeForm = async (body: AuthBodyType, form: ChecklistType | RefactoredChecklistType, modeloQrCode?: ModeloQRCode, deleteQrCodes?: boolean) => {
    try {
      const legacyForm = form as ChecklistType;
      legacyForm.itens = legacyForm.itens.map((item) => ({
        ...item,
        subitens: item.subitens.map((subitem) => {
          if (!["numero", "valorMedida"].includes(subitem.tipo)) return subitem;

          const parseOptionalNumber = (value: unknown): number | null | undefined => {
            if (value === "" || value === null || value === undefined) {
              return null;
            }

            const parsed = parseFloat(String(value));

            return Number.isNaN(parsed) ? null : parsed;
          };

          return {
            ...subitem,
            padrao: subitem.padrao ? parseOptionalNumber(subitem.padrao) : subitem.padrao,
            min: subitem.min ? parseOptionalNumber(subitem.min) : subitem.min,
            max: subitem.max ? parseOptionalNumber(subitem.max) : subitem.max,
            minNumberVal: subitem.minNumberVal ? parseOptionalNumber(subitem.minNumberVal) : subitem.minNumberVal,
            maxNumberVal: subitem.maxNumberVal ? parseOptionalNumber(subitem.maxNumberVal) : subitem.maxNumberVal
          };
        }),
      }));
      const data: AxiosResponse = await api.post("/checklists/changeForm", {
        ...body,
        form: legacyForm,
        modeloQrCode,
        deleteQrCodes,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  duplicaForm = async (
    body: AuthBodyType & {
      formId: string;
    },
  ) => {
    try {
      const data: AxiosResponse = await api.post("/checklists/duplicaForm", {
        ...body,
      });
      return data.data.forms;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  unassociateType = async (
    body: AuthBodyType & {
      formId: string;
      typeId: string;
    },
  ) => {
    try {
      const data: AxiosResponse = await api.post("/checklists/desassociar", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  getSimpleForm = async (body: AuthBodyType, planoDeAcao?: boolean) => {
    try {
      const data: AxiosResponse = await api.post("/checklists/getChecklistSimples", {
        ...body,
        planoDeAcao,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  getFormConfigData = async (body: AuthBodyType, formulario: string, cliente: string) => {
    try {
      const data: AxiosResponse = await api.post("/checklists/getClienteFormulario", {
        ...body,
        formulario,
        cliente,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  editConfigForm = async (
    body: AuthBodyType,
    formulario: string,
    cliente: string,
    clienteFormulario: {
      chamadoObrigatorio: boolean;
      cliente: string;
      delegacao: boolean;
      distanciaLimite: number | null;
      duracaoValidade: number;
      empresa: string;
      formulario: string;
      gravaPOS: boolean;
      id: string;
      limiteChamado: number;
      qrcode: boolean;
      tipoChamado: number[];
      tipoValidade: string | null;
    },
  ) => {
    try {
      const data: AxiosResponse = await api.post("/checklists/editClienteFormulario", {
        ...body,
        formulario,
        cliente,
        clienteFormulario,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  getOptionsBySubitem = async (body: AuthBodyType, formulario: string, cliente: string, subId: string | null, subIndex: number, itemid: string) => {
    try {
      const data: AxiosResponse = await api.post("/checklists/getOptionsBySubitem", {
        ...body,
        formulario,
        cliente,
        subId,
        subIndex,
        itemid,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  editOptionsForSubitem = async (
    body: AuthBodyType,
    formulario: string,
    cliente: string,
    subId: string | null,
    subIndex: number,
    itemid: string,
    options: OptionsType,
  ) => {
    try {
      const data: AxiosResponse = await api.post("/checklists/editOptionsForSubitem", {
        ...body,
        formulario,
        cliente,
        subId,
        subIndex,
        itemid,
        options,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  getPreenchimentoWeb = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/checklists/getPreenchimentoWeb", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  getChecklistForWebFilling = async (token: AuthBodyType | null, formId: string, deslogado: boolean) => {
    try {
      const data: AxiosResponse = await api.post("/checklists/getChecklistForWebFilling", {
        ...token,
        formId,
        deslogado,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  changeRange = async (token: AuthBodyType, itemRange: { index: number; name: string; range: number }[] | null, checked: boolean, formId: string) => {
    try {
      const data: AxiosResponse = await api.post("/checklists/changeRange", {
        ...token,
        itemRange,
        checked,
        formId,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        return error.response?.status;
      }
    }
  };

  getSimples = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/checklists/getChecklistWebSimples", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };
  getMedidas = async (body: AuthBodyType | null) => {
    try {
      const data: AxiosResponse = await api.post("/checklists/getMedidas", { ...body });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        return error.response?.status;
      }
    }
  };

  cancelaExecucao = async (token: AuthBodyType, body: { inicio: number, user: string }) => {
    try {
      const data: AxiosResponse = await api.post("/checklists/cancelaExecucao", { ...token, ...body });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        return error.response?.status;
      }
    }
  };
}

export default Checklists;
